import { render, staticRenderFns } from "./ViewVehicleConfiguration.vue?vue&type=template&id=44e38b79&scoped=true"
import script from "./ViewVehicleConfiguration.vue?vue&type=script&lang=js"
export * from "./ViewVehicleConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e38b79",
  null
  
)

export default component.exports